import { ManageCapacityViewPage } from "../../../web/pages/ManageCapacity";
import React from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { getNetworkStatus, getUserMasterData } from "../../../selectors/selector";
import { showNetworkAlert } from "../../../actions/App/action";
import { countryStateCodesSelector, getSelectedManageCapacity } from "../../../selectors/Manage/selector";
import { getCountryStateCodes } from '../../../actions/manage/action';

export const ManageCapacityViewContainer: React.FC<any> = (props: any) => {
  return props.selectedCapacity ? (
    <ManageCapacityViewPage {...props} module="manage/ManageMyCapacity" />
  ) : null;
};

const mapStateToProps = createStructuredSelector({
  isNetworkAvailable: getNetworkStatus(),
  userDetails: getUserMasterData(),
  selectedCapacity: getSelectedManageCapacity(),
  countryStateCodes: countryStateCodesSelector()
});

export const mapDispatchToProps = (dispatch: Function) => ({
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  getCountryStateCodes: () => dispatch(getCountryStateCodes())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCapacityViewContainer);
